import FormControl from "common/components/FormControl/FormControl";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { Zone } from "types";
import MapField from "common/components/MapField/MapField";
import CrudForm from "common/components/Crud/CrudForm";

type Props = {
  onSubmit: (values: any) => any;
  onCancel?: () => void;
  item?: Zone;
};

function ZoneForm({ onSubmit, onCancel, item }: Props) {
  const { t } = useTranslation();

  const initialValues = useMemo(
    () =>
      item?.id
        ? {
            ...item,
          }
        : {},
    [item]
  );

  const handleSubmit = (payload: any) => {
    const data = payload?.data ?? payload;
    const { geojsonTemp, ...rest } = data;

    return onSubmit({
      ...payload,
      data: {
        ...rest,
        lat: rest.lat ?? geojsonTemp?.lat,
        lng: rest.lng ?? geojsonTemp?.lng,
      },
    });
  };

  return (
    <CrudForm
      onSubmit={handleSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
      headerIcon="MapPinIcon"
      i18nNamespace="zones"
      additionalMutators={{
        setPosition: (args: any, state: any, utils: any) => {
          const position = args[0];

          utils.changeValue(state, "lat", () => position.lat);
          utils.changeValue(state, "lng", () => position.lng);
        },
        setHelpPosition: (
          [_, geo]: any,
          state: any,
          utils: {
            changeValue: (
              arg0: any,
              arg1: string,
              arg2: { (): any; (): any }
            ) => void;
          }
        ) => {
          utils.changeValue(
            state,
            "geojsonTemp.lat",
            () => geo && geo.location?.lat()
          );
          utils.changeValue(
            state,
            "geojsonTemp.lng",
            () => geo && geo.location?.lng()
          );
        },
      }}
      render={(values, form) => (
        <div className="flex flex-col gap-4">
          <div className="flex flex-row flex-wrap gap-4">
            <div className="flex flex-col flex-[2] gap-4 white-box">
              <div className="flex flex-row gap-4">
                <FormControl
                  name="name"
                  title={t("zones.name")}
                  required
                  containerStyle="flex-1"
                />
                <FormControl
                  name="zoneID"
                  title={t("zones.zoneID")}
                  type="number"
                  containerStyle="flex-1"
                  editable={!item?.id}
                />
              </div>
              <div className="flex flex-row gap-4">
                <FormControl
                  name="city"
                  title={t("zones.city")}
                  containerStyle="flex-1"
                />
                <FormControl
                  name="cooperative"
                  title={t("zones.cooperative")}
                  containerStyle="flex-1"
                />
              </div>
              <FormControl
                name="referent"
                title={t("zones.referent")}
                containerStyle="flex-1"
              />
            </div>
            <div className="flex flex-col flex-1 gap-2 white-box">
              <MapField
                position={{
                  lat: values.lat ?? 7.54,
                  lng: values.lng ?? -5.55,
                }}
                positionTemp={{
                  lat: values.geojsonTemp?.lat ?? values.lat ?? 7.54,
                  lng: values.geojsonTemp?.lng ?? values.lng ?? -5.55,
                }}
                onChange={form.mutators.setPosition}
                editable
                mapPrefix="zoneForm"
                form={form}
              />
            </div>
          </div>
          <div className="white-box">
            <FormControl
              name="description"
              title={t("zones.description")}
              type="textarea"
              containerStyle="w-full"
            />
          </div>
          <div className="white-box">
            <FormControl
              name="enabled"
              title={t("zones.enabled")}
              type="checkbox"
            />
          </div>
        </div>
      )}
    />
  );
}

export default ZoneForm;
